<template>
    <C1Modal
        v-if="isModalOpen"
        v-model="isOpen"
        modal-content-class="af-modal reference-modal afu-p-4 md:afu-p-8 md:afu-pt-6"
        size="xl"
        @hidden="close"
    >
        <template v-slot:body>
            <ValidationObserver
                ref="submitForm"
                tag="form"
                @submit.stop.prevent="onSubmit"
            >
                <div class="afu-flex afu-items-center af-text--4xl afu-text-black afu-mb-8">
                    <span class="afu-mr-3 afu-text-900">
                        <FontAwesomeIcon :icon="['far', 'plus']" />
                    </span>
                    <span class="afu-font-bold">
                        {{ `${reference.id ? $t('label.edit_value', {value: $t('label.reference')}) : $t('label.add_value', {value: $t('label.reference')}) }` }}
                    </span>
                </div>
                <ReferenceForm
                    :reference="reference"
                    @change="onReferenceChange"
                />

                <div class="afu-flex afu-items-center afu-justify-center">
                    <C1Button
                        :disabled="spinner.destroy"
                        variant="outline-secondary"
                        @click="$emit('closeModal')"
                    >
                        {{ $t('label.cancel') }}
                    </C1Button>
                    <C1Button
                        :is-busy="spinner.save"
                        variant="outline-primary"
                        class="afu-ml-2"
                        type="submit"
                    >
                        {{ $t('label.save_value', {value: $t('label.reference')}) }}
                    </C1Button>
                </div>
            </ValidationObserver>
        </template>
    </C1Modal>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';
    import ReferenceForm from '@/apps/dashboard/001/components/Reference/ReferenceForm';
    import C1Button from '@/components/C1Components/C1Button';
    import C1Modal from '@/components/C1Components/C1Modal';
    import { ValidationObserver } from 'vee-validate';

    export default {
        name: 'ReferenceModal',

        components: {
            C1Button,
            ReferenceForm,
            C1Modal,
            ValidationObserver,
        },

        props: {
            reference: {
                type: Object,
                default: () => ({}),
            },
            isModalOpen: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isOpen: false,
                form: {},
                spinner: {
                    destroy: false,
                    save: false,
                },
                error: '',
            };
        },

        computed: {
            showSaveButton() {
                return !this.shouldDestroy;
            },
        },

        created() {},

        beforeDestroy() {},

        methods: {
            ...mapMutations('me', {
                $_STORE_REFERENCE: 'STORE_REFERENCE',
                $_PUT_REFERENCE: 'PUT_REFERENCE',
            }),

            ...mapActions('me', {
                $_getReferences: 'getReferences',
                $_storeReference: 'storeReference',
                $_updateReference: 'updateReference',
            }),

            onReferenceChange(form) {
                this.form = form;
            },

            async onSubmit() {
                const validate = await this.$refs.submitForm.validate();
                if (!validate) {
                    return;
                }

                const payload = {
                    first_name: this.form.first_name,
                    last_name: this.form.last_name,
                    position: this.form.position,
                    company: this.form.company,
                    phone_number: this.form.phone_number,
                    mobile_number: this.form.mobile_number,
                    email_address: this.form.email_address,
                    is_report_directly: this.form.is_report_directly.value,
                    is_contactable: this.form.is_contactable.value,
                };

                if (this.form.id) {
                    this.updateReference(this.form.id, payload);
                } else {
                    this.storeReference(payload);
                }
            },

            storeReference(data) {
                this.spinner.save = true;
                this.$_storeReference(data)
                    .then(() => {
                        this.$_getReferences().then(response => {
                            this.$_STORE_REFERENCE(response.data);
                        });
                        this.closeModal();
                    })
                    .finally(() => {
                        this.spinner.save = false;
                    });
            },

            updateReference(id, data) {
                this.spinner.save = true;
                this.$_updateReference({ id, data })
                    .then(response => {
                        this.$_PUT_REFERENCE(response.data);
                        this.closeModal();
                    })
                    .finally(() => {
                        this.spinner.save = false;
                    });
            },

            close() {
                this.$emit('close');
            },

            closeModal() {
                this.close();
            },
        },
    };
</script>
